import type { ColumnsType } from "antd/es/table"
import type { TPriceField, TPricingTableRow } from "types/modelNumbers.type"

export type TPricingCellKey = "series" | TPriceField

type Props = {
	renderCellValue: (params: {
		value: string | number | undefined
		hasPrices: boolean
		cellKey: TPricingCellKey
		seriesId: number
	}) => JSX.Element
	getCellClassName?: (params: { cellKey: TPricingCellKey; seriesId: number }) => string
}

export const PricingTableColumns = ({ renderCellValue, getCellClassName }: Props): ColumnsType<TPricingTableRow> => {
	return [
		{
			title: "SERIES",
			dataIndex: "series",
			key: "series",
			width: "70%",
			render: (value: string, record) =>
				renderCellValue({
					value,
					hasPrices: record.hasPrices,
					cellKey: "series",
					seriesId: record.series_id,
				}),
		},
		{
			title: "MIN PRICE",
			dataIndex: "min_price",
			key: "min_price",
			width: "10%",
			render: (value: number | undefined, record) =>
				renderCellValue({
					value,
					hasPrices: record.hasPrices,
					cellKey: "min_price",
					seriesId: record.series_id,
				}),
			onCell: (record) => ({
				className: getCellClassName?.({ cellKey: "min_price", seriesId: record.series_id }) ?? "",
			}),
		},
		{
			title: "AVG PRICE",
			dataIndex: "avg_price",
			key: "avg_price",
			width: "10%",
			render: (value: number | undefined, record) =>
				renderCellValue({
					value,
					hasPrices: record.hasPrices,
					cellKey: "avg_price",
					seriesId: record.series_id,
				}),
			onCell: (record) => ({
				className: getCellClassName?.({ cellKey: "avg_price", seriesId: record.series_id }) ?? "",
			}),
		},
		{
			title: "MAX PRICE",
			dataIndex: "max_price",
			width: "10%",
			key: "max_price",
			render: (value: number | undefined, record) =>
				renderCellValue({
					value,
					hasPrices: record.hasPrices,
					cellKey: "max_price",
					seriesId: record.series_id,
				}),
			onCell: (record) => ({
				className: getCellClassName?.({ cellKey: "max_price", seriesId: record.series_id }) ?? "",
			}),
		},
	]
}
